import { render } from "./BarChartCanvas.vue?vue&type=template&id=83b6d2e2&scoped=true"
import script from "./BarChartCanvas.vue?vue&type=script&lang=js"
export * from "./BarChartCanvas.vue?vue&type=script&lang=js"

import "./BarChartCanvas.vue?vue&type=style&index=0&id=83b6d2e2&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83b6d2e2"]])

export default __exports__